import { FC, useEffect, useState } from 'react';
import { Box, Grid, FormControl, TextField, Select, MenuItem, InputLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../../../atomic/atoms';
import { SCUIGeneralDrawerHeader } from '../../../../atomic/molecules';
import { SCUIConfirmDialog } from '../SCUIConfirmDialog/SCUIConfirmDialog';
import { CargoShipmentFeeManagement, initialState } from '../../Cargo.helper';
import { CSF } from '../../cargoShippingFeeManagement.classes';

interface IProps {
    selectedRow?: any;
    onClose?: any;
    setDatas?: any;
    datas?: CargoShipmentFeeManagement[];
}

export const SCUICargoEdit: FC<IProps> = ({ selectedRow, onClose, setDatas, datas }) => {
    const { t } = useTranslation();
    const [drawerConfirmOpen, setDrawerConfirmOpen] = useState(false);
    const [updatedValue, setUpdatedValue] = useState(initialState.updatedShippingFee);
    let conditionList = [
        { id: 1, name: '<' },
        { id: 2, name: '>=' },
    ];

    const handleClickOpenConfirmDialog = () => {
        setDrawerConfirmOpen(true);
    };
    const handleCloseConfirmDialog = () => {
        setDrawerConfirmOpen(false);
    };
    useEffect(() => {
        setUpdatedValue({ ...updatedValue, id: selectedRow.id });
    }, []);

    return (
        <form
            className={CSF.editForm}
            onSubmit={(e: any) => {
                e.preventDefault();
                handleClickOpenConfirmDialog();
            }}
        >
            <div
                className={`commentFilterContainer ${CSF.editContainer}`}
                data-id={selectedRow?.id}
            >
                <SCUIConfirmDialog
                    open={drawerConfirmOpen}
                    onClose={handleCloseConfirmDialog}
                    selectedRow={selectedRow}
                    dialogContent={t('general.updateConfirmationText')}
                    buttonNameAccept={t('general.yes')}
                    buttonNameReject={t('general.no')}
                    actionType="update"
                    closeEditModal={onClose}
                    datas={datas}
                    setDatas={setDatas}
                    updatedRow={updatedValue}
                    uploadDatas={[]}
                    setUploadDatas={null}
                ></SCUIConfirmDialog>

                <Grid container spacing={1}>
                    <Box className={CSF.editHeader}>
                        <SCUIGeneralDrawerHeader header={t('general.limitUpdate')} onClose={onClose} />
                    </Box>
                    <Grid
                        className={`${CSF.editInfoRow} ${CSF.editInfoCargoCompany}`}
                        data-cargo-company={selectedRow?.cargoCompany}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <label>{selectedRow && t('general.cargoCompany') + ' : ' + selectedRow.cargoCompany}</label>
                    </Grid>
                    <Grid
                        className={`${CSF.editInfoRow} ${CSF.editInfoDeliveryType}`}
                        data-delivery-type={selectedRow?.deliveryType}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <label>{selectedRow && t('general.deliveryType') + ' : ' + selectedRow.deliveryType}</label>
                    </Grid>
                    <Grid
                        className={CSF.editFieldsBox}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <Grid
                            className={CSF.editFieldShoppingAmount}
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <TextField
                                className={CSF.inputEditShoppingAmount}
                                label={t('general.shoppingAmount')}
                                defaultValue={selectedRow && selectedRow.shoppingAmount}
                                variant="outlined"
                                type="text"
                                id="shoppingAmountText"
                                fullWidth
                                onChange={(event) => {
                                    setUpdatedValue({ ...updatedValue, shoppingAmount: event.target.value });
                                }}
                            />
                        </Grid>
                        <Grid
                            className={CSF.editFieldShipmentFee}
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <TextField
                                className={CSF.inputEditShipmentFee}
                                id="shipmentFeeText"
                                defaultValue={selectedRow && selectedRow.shipmentFee}
                                type="text"
                                label={t('general.shipmentFee')}
                                fullWidth
                                onChange={(event) => {
                                    setUpdatedValue({ ...updatedValue, shipmentFee: event.target.value });
                                }}
                            />
                        </Grid>
                        <Grid
                            className={CSF.editFieldCondition}
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <FormControl fullWidth>
                                <InputLabel id="conditionLabel">{t('general.condition')}</InputLabel>
                                <Select
                                    className={CSF.inputEditCondition}
                                    fullWidth
                                    labelId="conditionLabel"
                                    label={t('general.condition')}
                                    id="conditionSelect"
                                    defaultValue={selectedRow.condition}
                                    onChange={(event) => {
                                        setUpdatedValue({ ...updatedValue, condition: event.target.value });
                                    }}
                                >
                                    {conditionList && conditionList.length > 0 ? (
                                        conditionList.map((condition: any, index: number) => (
                                            <MenuItem
                                                value={condition.name}
                                                key={index}
                                                className={CSF.editConditionOption}
                                                data-condition-id={condition.id}
                                                data-condition-name={condition.name}
                                            >
                                                {condition.name}
                                            </MenuItem>
                                        ))
                                    ) : (
                                        <div style={{ display: 'none' }}></div>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1} sx={{ minHeight: { xs: 250, lg: 450 }, paddingBottom: '1rem' }}></Grid>
                    <Grid
                        className={CSF.editActionsBox}
                        style={{ position: 'absolute', bottom: 0, width: 380, marginBottom: '20px' }}
                    >
                        <SCUIButton
                            className={CSF.btnEditSubmit}
                            text={t('general.update')}
                            type="primary"
                            sizeType="default"
                            buttonType="submit"
                            size={'s'}
                            fullwidth
                        />
                    </Grid>
                </Grid>
            </div>
        </form>
    );
};
